import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgLateDeparture = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.605 6.75c.247.625.98.92 1.637.66.331-.13.58-.377.713-.67m4.555.01c-.246.625-.98.92-1.636.66a1.31 1.31 0 0 1-.714-.67m3.93-4.147c0 1.045-1.127 1.9-2.517 1.9h-.752c-.85 0-1.687 1.326-1.821 1.326-.134 0-.972-1.326-1.821-1.326h-.752c-1.39 0-2.518-.855-2.518-1.9"
      stroke="#4D4D4D"
    />
    <path d="M14.264 4.985a4.734 4.734 0 1 1-8.527 0" stroke="#4D4D4D" />
    <path
      d="M10.829 8.594c0 .635-.829 1.866-.829 1.866s-.829-1.23-.829-1.866c0-.636.371-.645.829-.645.458 0 .829.009.829.645Z"
      fill="#4D4D4D"
    />
    <path
      d="m5.447 8.243-.614 8.587c.386 0 .901-.004 1.462-.063m4.038-3.79c-.05 1.995-1.13 2.957-2.373 3.421m-1.665.369.31-4.02m-.31 4.02a6.854 6.854 0 0 0 1.665-.369m0 0 .178-2.261"
      stroke="#4D4D4D"
    />
    <path
      d="M14.734 7.115v5.4c0 2.665-2.09 4.826-4.668 4.826a4.546 4.546 0 0 1-2.724-.906m3.929.905v1.034M9.799 17.34v1.034"
      stroke="#4D4D4D"
    />
  </svg>
);
const Memo = memo(SvgLateDeparture);
export default Memo;
